import React from "react";

const features = [
  {
    icon: "💰",
    title: "Affordable TV & Washing Machine Repair in Pune",
    desc: "We offer affordable TV repair and washing machine repair in Pune & Pimpri-Chinchwad with transparent pricing and no hidden charges. If you are searching for repair services near me, we provide cost-effective solutions with free diagnosis.",
    colorClass: "why-icon-green",
  },
  {
    icon: "👨‍🔧",
    title: "Expert LED, LCD & Appliance Technicians",
    desc: "Our certified technicians have 10+ years of experience in LED TV repair, LCD TV repair, Smart TV repair and washing machine repair. We handle all major brands including Samsung, LG, Sony, Mi, Whirlpool, Bosch and more.",
    colorClass: "why-icon-blue",
  },
  {
    icon: "🛡️",
    title: "Warranty on All Repair Services",
    desc: "We provide warranty on every TV repair and washing machine repair service in Pune. Our goal is to deliver reliable and long-lasting repair solutions with complete customer satisfaction.",
    colorClass: "why-icon-amber",
  },
  {
    icon: "🚀",
    title: "Same-Day Doorstep Service Near You",
    desc: "Looking for TV repair near me or washing machine repair near me? We offer same-day doorstep service in Pune & Pimpri-Chinchwad with fast turnaround and professional support.",
    colorClass: "why-icon-purple",
  },
];

const AboutSection = () => {
  return (
    <section
      id="about-section"
      className="section"
      aria-label="TV and Washing Machine Repair Services in Pune and Pimpri-Chinchwad"
    >
      <div className="section-inner">
        <div className="section-header">
          <div className="section-label">Why Choose Us</div>

          <h2 className="section-title">
            The Mauli Services Difference
          </h2>

          <p className="section-subtitle">
            Mauli Services is a trusted name for TV repair near me and washing machine repair in Pune.
            We provide LED TV repair, LCD TV repair, Smart TV repair and appliance repair services
            with fast doorstep support across Pimpri-Chinchwad and nearby areas.
          </p>
        </div>

        <div className="why-grid">
          {features.map((feature, index) => (
            <div key={index} className="why-card">
              <div className={`why-icon ${feature.colorClass}`}>
                {feature.icon}
              </div>

              <div>
                <h3 className="why-title">{feature.title}</h3>
                <p className="why-desc">{feature.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* ✅ Small SEO reinforcement (visible, clean) */}
        {/* <p className="seo-text">
          We provide TV repair near me in Pimpri-Chinchwad and washing machine repair near me in Pune,
          including LED TV repair, LCD TV repair, Smart TV repair and complete appliance repair services
          at your doorstep.
        </p> */}
      </div>
    </section>
  );
};

export default AboutSection;